import type { PluginDefaultTranslationsObject } from '../types.js'

export const fa: PluginDefaultTranslationsObject = {
  '@seshuk/payload-storage-bunny': {
    // TUS Upload
    tusUploadChecking: 'بررسی آپلودهای قبلی...',
    tusUploadDisableMode: 'غیرفعال کردن حالت TUS',
    tusUploadEnableMode: 'فعال کردن حالت TUS',
    tusUploadErrorFileType: 'نوع فایل مجاز نیست',
    tusUploadErrorInitUpload: 'مقداردهی اولیه آپلود ناموفق',
    tusUploadErrorPrevCheckFail: 'بررسی آپلودهای قبلی ناموفق',
    tusUploadErrorRestoreUpload: 'بازیابی آپلود ناموفق',
    tusUploadFileSize: '{{size}} مگابایت',
    tusUploadFinalizing: 'در حال نهایی کردن...',
    tusUploadPause: 'مکث',
    tusUploadPreparing: 'آماده‌سازی آپلود...',
    tusUploadResume: 'ادامه',
    tusUploadRetry: 'تلاش مجدد',
    tusUploadStartOver: 'شروع دوباره',
    tusUploadStartUpload: 'شروع آپلود',
    tusUploadStatusChecking: 'بررسی آپلودهای قبلی...',
    tusUploadStatusCompleted: 'آپلود با موفقیت تکمیل شد!',
    tusUploadStatusFinalizing: 'نهایی کردن آپلود...',
    tusUploadStatusIdle: 'آماده آپلود',
    tusUploadStatusIdleWithRestore: 'آماده ادامه یا شروع دوباره',
    tusUploadStatusPaused: 'آپلود در {{progress}}% متوقف شد',
    tusUploadStatusUploading: 'در حال آپلود... {{progress}}%',
    tusUploadTimeHours: 'س',
    tusUploadTimeMinutes: 'د',
    tusUploadTimeSeconds: 'ث',

    // Error messages
    errorAccessDenied: 'شما مجوز دسترسی به این منبع را ندارید',
    errorDeleteFileFailed: 'حذف فایل امکان‌پذیر نبود: {{filename}}',
    errorMissingRequiredFields: 'برخی اطلاعات ضروری موجود نیست',
    errorNoServiceConfigured: 'هیچ سرویسی پیکربندی نشده است',
    errorStreamConfigMissing: 'Bunny Stream به درستی پیکربندی نشده است',
    errorTitleRequired: 'لطفاً عنوانی برای ویدیوی خود وارد کنید',
    errorUploadFileFailed: 'آپلود فایل امکان‌پذیر نبود: {{filename}}',
  },
}
